export const SEASON_PLAYER_STANDINGS_QUERY_KEY = 'SEASON_PLAYER_STANDINGS_QUERY_KEY';

export const playerStatKeys = {
	playerStats: (organizationUuid: string, teamLeagueUuid: string, seasonUuid: string, playerUuid: string) =>
		[`PLAYER_STATS`, organizationUuid, teamLeagueUuid, seasonUuid, playerUuid] as const,
	players: (organizationUuid: string, teamLeagueUuid: string, serializedSearchParams: string) =>
		['PLAYERS', organizationUuid, teamLeagueUuid, serializedSearchParams] as const
};
